import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminAuth = () => {
  const t = localStorage.getItem("admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const imageUrl = (src) => {
  if (!src) return src;
  return src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src;
};

const CATEGORY_LABELS = {
  tshirt: "TEE",
  tumbler: "TUMBLER",
  mug: "MUG",
  handmade: "HAND MADE",
  other: "OTHER",
};

export const categoryLabel = (cat) => CATEGORY_LABELS[cat] || (cat ? cat.toUpperCase() : "ITEM");
